import { render } from "./PromotionDetails.vue?vue&type=template&id=644b65f4"
import script from "./PromotionDetails.vue?vue&type=script&lang=js"
export * from "./PromotionDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__